import {inject, injectable} from 'inversify';

import type {Expand, MaybeExpanded} from '../../../../api/types';
import type {TenantMapperJrpc} from '../../Tenant/mappers/Tenant.mapper.jrpc';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class SubtenantExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {subtenant: ['tenant_id']};
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace SubtenantExpandJrpc {
  export type ExpandedFields = {
    tenant: MaybeExpanded<TenantMapperJrpc.ApiData>;
  };
}
